
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PipelineAssetLocationDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-pipeline-asset-location',
  templateUrl: './pipeline-asset-location.component.html',
  styleUrls: ['./pipeline-asset-location.component.scss']
})
export class PipelineAssetLocationComponent implements OnInit {


  pipelineassetlocationForm: FormGroup;
  control = new FormControl();
  @Input() pipelineassetlocations: PipelineAssetLocationDto[];
  @Input() routeAnimationsElements: any;
  @Output() pipelineassetlocation = new EventEmitter<PipelineAssetLocationDto[]>()
  @Output() deletePipelineAssetLocationEvent = new EventEmitter<any>()

    selectedPipelineAssetLocation: any;
    filteredDelete: Array<any> =[];
    loading = true;
    constructor(
     private fb: FormBuilder,
     private router: Router,
     private snackBar: MatSnackBar
     ) {}

    ngOnInit() {
       this.pipelineassetlocationForm = this.fb.group({PipelineAssetLocations: this.fb.array([])});
    }

    ngAfterViewInit() {
      setTimeout(() => {
        console.log("data: ", this.pipelineassetlocations);

          this.loading = false;
          this.setPipelineAssetLocation();
      }, 700)
    }


  // method to display pipelineassetlocations
  setPipelineAssetLocation() {
    console.log("data...: ", this.pipelineassetlocations);
    const control  = this.pipelineassetlocationForm.controls.PipelineAssetLocations as FormArray;
    this.pipelineassetlocations.forEach( e => {
      control.push(
        this.fb.group({
          PipelineAssetLocationName: e.PipelineAssetLocationName,
          id: e.id
        })
      );
    });
  }


  // method to add PipelineAssetLocation
  addPipelineAssetLocation() {
    const control  = this.pipelineassetlocationForm.controls.PipelineAssetLocations as FormArray;
    control.insert(0,
          this.fb.group({
            PipelineAssetLocationName: ['', Validators.required],
            id: null
          })
       );
  }


  // method to delete pipelineassetlocation from arrary list
  deletePipelineAssetLocation(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.pipelineassetlocationForm.controls.PipelineAssetLocations as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.pipelineassetlocations.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.pipelineassetlocations[i].id);
          console.log('delete: ', JSON.stringify(value));
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }
  onSubmit(formValue: any) {
  this.pipelineassetlocation.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deletePipelineAssetLocationEvent.emit(this.filteredDelete);
  }
  }

}
